import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker management
//   sw.js v2/v3 (older) buggy — older versions intercepted /api/* and returned
//   bogus 504 fallback responses. v4 is a no-op passthrough SW. On every page
//   load until users have upgraded past v4, we hard-purge any older SW.
const SW_VERSION = 'v4';
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const installed = localStorage.getItem('sw_version');
      if (installed !== SW_VERSION) {
        // Wipe out the old SW + caches
        const regs = await navigator.serviceWorker.getRegistrations();
        for (const reg of regs) {
          await reg.unregister();
        }
        if (typeof caches !== 'undefined' && caches.keys) {
          const names = await caches.keys();
          await Promise.all(names.map((n) => caches.delete(n)));
        }
        localStorage.setItem('sw_version', SW_VERSION);
      }
      // Register the (now-fresh) passthrough SW
      await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    } catch (e) {
      // Never crash app boot because of SW issues
      // eslint-disable-next-line no-console
      console.warn('[SW] setup failed', e);
    }
  });
}
